<template>
    <div>
        <b-card no-body class="mb-3 pl-3 pr-3 pt-3 pb-3">
			<h2>
                <i class="fa fa-arrow-left mr-3" v-if="type != 'PartsOnly'" @click="$router.push({name : 'EstimatorApplication' , params : { 'id' : form_code}})" style="cursor:pointer"></i>
                <i class="fa fa-arrow-left mr-3" v-else @click="$router.push({name : 'EstimatorParts' , params : { 'id' : form_code}})" style="cursor:pointer"></i>
                Tambah Estimasi
            </h2>
		</b-card>

        <!-- <b-card no-body>
            <b-tabs pills vertical>
                <b-tab title="Tab 1" active><b-card-text>Tab contents 1</b-card-text></b-tab>
                <b-tab title="Tab 2"><b-card-text>Tab contents 2</b-card-text></b-tab>
                <b-tab title="Tab 3"><b-card-text>Tab contents 3</b-card-text></b-tab>
            </b-tabs>
        </b-card> -->

        <div class="row mb-3">
            <div class="col-6 offset-6">
                <button class="w-100 btn btn-success" @click="submitForm()">Konfirmasi Penambahan Estimasi</button>
            </div>
        </div>

        <b-card no-body class="pl-3 pr-3 pt-3 pb-3">
            <h5>Tambah Estimasi</h5>
            <table class="table mt-1">
                <thead>
                    <th>No.</th>
                    <th>Tipe</th>
                    <th>Nama</th>
                    <th>Jumlah</th>
                    <th>Sparepart Size</th>
                    <th>Deskripsi</th>
                    <th>Tipe</th>
                    <th>Extension</th>
                    <th>Harga</th>
                    
                    <th><i class="fa fa-cog"></i></th>
                </thead>
                <tbody>
                    <tr v-for="(estimation , index) in estimationSubmitList">
                        <td>{{index + 1}}.</td>
                        <td>{{estimation.selected}}</td>
                        <td>{{estimation.sparepartInfo.sparepart_variants.alias}}</td>
                        <td>{{estimation.amount}}</td>
                        <td>{{estimation.sparepart_size}}</td>
                        <td>{{estimation.part_number}}</td>
                        <td>{{estimation.type}}</td>
                        <td>{{estimation.extension}}</td>
                        <td>{{estimation.price_per_item ? numberWithCommas(estimation.price_per_item) : '-'}}</td>
                        <td>
                            <button class="btn btn-danger" @click="estimationSubmitList.splice(index, 1)"><i class="fa fa-times-circle"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-card>

        <b-card no-body class="pl-3 pr-3 pt-3 pb-3 mt-3 scrollable-card">
            <div v-if="page == 1">
                <h5>Pilih Tipe Penambahan Estimasi</h5>
                <div class="mt-4 row">
                    <div class="col-md pl-3 pr-3">
                        <div class="shadow rounded flexify hoverable height-tipe" @click="selected = 'Part';page = 2">
                            <div>
                                <i class="fa fa-cog fa-5x"></i>
                            </div>
                            <div class="mt-3">
                                <h5>Part</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md pl-3 pr-3">
                        <div class="shadow rounded flexify hoverable height-tipe" @click="selected = 'Jasa';page = 2;data.amount = 1">
                            <i class="fa fa-tools fa-5x"></i>
                            <h5 class="mt-3">Jasa</h5>
                        </div>
                    </div>
                    <div class="col-md pl-3 pr-3">
                        <div class="shadow rounded flexify hoverable height-tipe" @click="selected = 'Special Bahan';page = 2;">
                            <i class="fa fa-boxes fa-5x"></i>
                            <h5 class="mt-3">Special Bahan</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="page == 2" style="height:550px">
                <h5><i class="fa fa-arrow-left mr-3" @click="page = 1" v-if="type != 'PartsOnly'" style="cursor:pointer"></i>Pilih {{selected}}</h5>

                <div class="pl-2 pr-2 mt-4">
                    <input class="form-control" :placeholder="'Cari ' + selected" v-model="search"/>
                </div>

                <div class="mt-2 row">
                    <div class="col-md-3 pl-3 pr-3 mt-3"  v-for="sparepart in sparepartMaster[selected].filter(x => x.alias.toLowerCase().includes(search.toLowerCase()) || x.name.toLowerCase().includes(search.toLowerCase())  )" @click="searchSparepartID(sparepart)">
                        <div class="shadow rounded flexify hoverable height-item sub-text text-center">
                            <div style="width:90%">
                                <h5>{{sparepart.alias}}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="page == 3" style="height:550px">
                <h5><i class="fa fa-arrow-left mr-3" @click="page = 2" style="cursor:pointer"></i>Isi Data {{selected}} - {{data.sparepartInfo.sparepart_variants.alias}}</h5>

                <div class="mt-4" v-if="selected == 'Part'">
                    <!-- <div class="row row-space">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="input-group">
                                <label class="label">Isi Deskripsi<span style="color: red;">*</span></label>
                                <input type="text" class="input--style-4" v-model="data.part_number"/>
                            </div>
                        </div>
                    </div> -->
                    <div class="row pl-3 pr-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Isi Deskripsi<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                            <input type="text" class="input--style-4" v-model="data.part_number"/>
                        </div>
                    </div>

                    <div class="row pl-3 pr-3 mt-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Jumlah Barang<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                            <input type="number" class="input--style-4" v-model="data.amount"/>
                        </div>
                    </div>
                    
                    <hr>

                    <div v-if="attachmentList.length > 0">
                        <!-- {{attachmentList}} -->
                        <h5>Part Services</h5>
                        <h6>Jika Sparepart tertentu dipilih, diharuskan isi jasa tersebut dibawah.</h6>

                        <div v-for="(attachment , index) in attachmentList" class="mt-4">
                            <h6>Jasa {{index + 1}} : {{attachment.sparepartInfo.sparepart_variants.alias}}</h6>
                            <div class="row pl-3 pr-3">
                                <div class="col-md-4 mt-auto mb-auto">
                                    <label class="label">Jasa Extension</label>
                                </div>
                                <div class="col-md-1 mt-auto mb-auto">
                                    <label class="label">:</label>
                                </div>
                                <div class="col-md-7">
                                    <multi-select
                                        class="mt-1"
                                        :options="attachment.sparepartInfo.sparepart_variants.extension.split(',')"
                                        placeholder="Pilih Extension Jasa"
                                        v-model="attachment.extension"
                                        :maxHeight="200"
                                    />
                                </div>
                            </div>

                            <div class="row pl-3 pr-3 mt-3">
                                <div class="col-md-4 mt-auto mb-auto">
                                    <label class="label">Tipe Jasa<span style="color: red;">*</span></label>
                                </div>
                                <div class="col-md-1 mt-auto mb-auto">
                                    <label class="label">:</label>
                                </div>
                                <div class="col-md-7">
                                    <multi-select
                                        class="mt-1"
                                        :options="['G/C' , 'R/C' , 'Special Repair', 'Inspeksi', 'B/P']"
                                        placeholder="Pilih Tipe Jasa"
                                        v-model="attachment.type"
                                        :maxHeight="200"
                                    />
                                </div>
                            </div>
                            <div class="row pl-3 pr-3 mt-3">
                                <div class="col-md-4 mt-auto mb-auto">
                                    <label class="label">Sparepart Size<span style="color: red;">*</span></label>
                                </div>
                                <div class="col-md-1 mt-auto mb-auto">
                                    <label class="label">:</label>
                                </div>
                                <div class="col-md-7">
                                    <multi-select
                                        class="mt-1"
                                        :options="options.sparepartSizes.map(x => x.id).sort()"
                                        :custom-label="opt => options.sparepartSizes.find(x => x.id == opt).name"
                                        label="name"
                                        placeholder="Pilih Sparepart Mobil"
                                        v-model="attachment.sparepart_size"
                                    />

                                </div>
                            </div>
                            <div class="row pl-3 pr-3 mt-3">
                                <div class="col-md-4 mt-auto mb-auto">
                                    <label class="label">Isi Deskripsi<span style="color: red;">*</span></label>
                                </div>
                                <div class="col-md-1 mt-auto mb-auto">
                                    <label class="label">:</label>
                                </div>
                                <div class="col-md-7">
                                    <input type="text" class="input--style-4" v-model="attachment.part_number"/>
                                </div>
                            </div>
                            <div class="row pl-3 pr-3 mt-3">
                                <div class="col-md-4 mt-auto mb-auto">
                                    <label class="label">Set Harga Jasa <span style="color:red">*</span></label>
                                </div>
                                <div class="col-md-1 mt-auto mb-auto">
                                    <label class="label">:</label>
                                </div>
                                <div class="col-md-7">
                                <input type="text" v-model="attachment.price_per_item" class="input--style-4" />
                                <div class="form-check form-check-inline col-12 mt-2">
                                        <input class="form-check-input" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="attachment.without_ppn">
                                        <label class="form-check-label" for="inlineCheckbox1">Non PPN</label>
                                    </div>
                                    <div class="form-check form-check-inline col-12">
                                        <input class="form-check-input" :disabled="data.without_ppn" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="attachment.ppn_included">
                                        <label class="form-check-label"  for="inlineCheckbox1">Harga Termasuk PPN</label>
                                    </div>
                                </div>
                            </div>

                            <hr>
                        </div>
                    </div>
                </div>

                <div class="mt-4" v-else-if="selected == 'Jasa'">
                    <!-- <div class="row row-space">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="input-group">
                                <label class="label">Isi Deskripsi<span style="color: red;">*</span></label>
                                <input type="text" class="input--style-4" v-model="data.part_number"/>
                            </div>
                        </div>
                    </div> -->
                    
                    <div class="row pl-3 pr-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Jasa Extension</label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                            <multi-select
                                v-if="extensionList"
                                :disabled="extensionList[0] == 'No Extension Available'"
                                class="mt-1"
                                :options="extensionList"
                                placeholder="Pilih Extension Jasa"
                                v-model="data.extension"
                                :maxHeight="200"
                            />
                        </div>
                    </div>

                    <div class="row pl-3 pr-3 mt-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Tipe Jasa<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                            <multi-select
                                class="mt-1"
                                :options="['G/C' , 'R/C' , 'Special Repair', 'Inspeksi', 'B/P']"
                                placeholder="Pilih Tipe Jasa"
                                v-model="data.type"
                                :maxHeight="200"
                            />
                        </div>
                    </div>

                    <div class="row pl-3 pr-3 mt-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Sparepart Size<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                            <multi-select
                                class="mt-1"
                                :options="options.sparepartSizes.map(x => x.id).sort()"
                                :custom-label="opt => options.sparepartSizes.find(x => x.id == opt).name"
                                label="name"
                                placeholder="Pilih Sparepart Mobil"
                                v-model="data.sparepart_size"
                            />

                        </div>
                    </div>

                    
                    <div class="row pl-3 pr-3 mt-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Isi Deskripsi<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                            <input type="text" class="input--style-4" v-model="data.part_number"/>
                            <div class="row mt-2">
                                <div class="col-4" v-for="description in descriptionList">
                                    <button class="btn btn-secondary" type="button" @click="updateDescription(description)">{{description}}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row pl-3 pr-3 mt-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Jumlah Barang<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                            <input type="number" class="input--style-4" disabled v-model="data.amount"/>
                        </div>
                    </div>

                    <!-- <div class="row pl-3 pr-3 mt-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Supply Apply<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                            <input type="number" class="input--style-4" v-model="data.modal_jasa"/>
                        </div>
                    </div> -->

                    <div class="row pl-3 pr-3 mt-3" v-if="price == 0">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Tambah Price List Jasa <span style="color:red">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                           <input type="text" v-model="addPriceList" class="input--style-4" />
                           <button
                            class="btn btn-info"
                            @click="addPriceListDB"
                            >
                                Tambah Price List
                            </button>
                        </div>
                    </div>

                    <div class="row pl-3 pr-3 mt-3" v-else>
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Set Harga Jasa <span style="color:red">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                           <input type="text" v-model="data.price_per_item" class="input--style-4" />
                           <div class="form-check form-check-inline col-12">
                                <input class="form-check-input" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="data.without_ppn">
                                <label class="form-check-label" for="inlineCheckbox1">Non PPN</label>
                            </div>
                            <div class="form-check form-check-inline col-12">
                                <input class="form-check-input" :disabled="data.without_ppn" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="data.ppn_included">
                                <label class="form-check-label"  for="inlineCheckbox1">Harga Termasuk PPN</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else-if="selected == 'Special Bahan'">

                    <div class="row pl-3 pr-3 mb-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Jumlah Stock</label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7 mt-auto mb-auto">
                            <!-- <input type="text" class="input--style-4" v-model="data.part_number"/> -->
                            <h5>{{numberWithCommas(data.sparepartInfo.stock)}}</h5>
                        </div>
                    </div>

                    <div class="row pl-3 pr-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Isi Deskripsi<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                            <input type="text" class="input--style-4" v-model="data.part_number"/>
                        </div>
                    </div>

                    <div class="row pl-3 pr-3 mt-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Jumlah Barang<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                            <input type="number" class="input--style-4" v-model="data.amount"/>
                        </div>
                    </div>

                    <div class="row pl-3 pr-3 mt-3">
                        <div class="col-md-4 mt-auto mb-auto">
                            <label class="label">Set Harga Special Bahan <span style="color:red">*</span></label>
                        </div>
                        <div class="col-md-1 mt-auto mb-auto">
                            <label class="label">:</label>
                        </div>
                        <div class="col-md-7">
                           <input type="text" v-model="data.price_per_item" class="input--style-4" />
                        </div>
                    </div>
                    <div class="row pl-3 pr-3 mt-3">
                        <div class="col-md-7 offset-md-5">
                            <div class="form-check form-check-inline col-12 mt-1">
                                <input class="form-check-input" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="data.without_ppn">
                                <label class="form-check-label" for="inlineCheckbox1">Non PPN</label>
                            </div>
                            <div class="form-check form-check-inline col-12 mt-1">
                                <input class="form-check-input" :disabled="data.without_ppn" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="data.ppn_included">
                                <label class="form-check-label"  for="inlineCheckbox1">Harga Termasuk PPN</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-4 ">
                    <div class="col-6 mb-4">
                        <button class="w-100 btn btn-danger">Batal</button>
                    </div>
                    <div class="col-6 mb-4" v-if="selected != 'Part'">
                        <button class="w-100 btn btn-primary" @click="addEstimationToTable()">Tambah Sparepart</button>
                    </div>
                    <div class="col-6 mb-4" v-else>
                        <button class="w-100 btn btn-primary" @click="addEstimationPart()">Tambah Sparepart</button>
                    </div>
                </div>
            </div>
        </b-card>

        
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components : {
        Multiselect
    },
    data () {
        return {
            options : this.$store.getters.getFilterOptions,
            page : 1,
            selected : null,
            sparepartMaster : null,
            search : '',
            form_code : null,
            insurancePriceList : null,
            form : null,
            brand_id : null,
            data : null,
            price : 0,
            estimationSubmitList : [],
            type : null,
            sparePart: {
                amount: 0,
                estimation_work_order_id: 0,
                sparepart_id: null,
                sparepart_size: null,
                attachment_id: null,
                insurance_car_type_id: null,
                insurance_company_id: null,
                without_ppn: false,
                type: null,
                extension : '',
                modal_jasa : null
            },
            formPriceList : null,
            extensionList : [],
            descriptionList : [],
            addPriceList : null,
            processSparepart : false,
            attachmentList : []
        }
    },
    mounted () {
        this.loadSparepartData()
        // console.log(this.$route.query)
        let keys = Object.keys(this.$route.query)

        for(var i = 0 ; i < keys.length ; i++) {
            let curQuery = this.$route.query[keys[i]]
            // console.log(curQuery , keys[i])

            // this.$set(this , keys[i] , curQuery)
            if(keys[i] == 'insurancePriceList' || keys[i] == 'form')
                this[keys[i]] = JSON.parse(curQuery)
            else
                this[keys[i]] = curQuery
            // console.log(this[keys[i]])
        }
        console.log(this.type)

        if(this.IsJsonString(this.data)){ 
            this.data = JSON.parse(this.data);
        }

        console.log(this.data)

        if(this.type != 'PartsOnly' ) {
            this.formPriceList = JSON.parse(JSON.stringify(this.form))
            this.sparePart.insurance_car_type_id = this.data.insurance_car_type_id
            this.sparePart.insurance_company_id = this.data.insurance_company_id
            this.sparePart.estimation_work_order_id = this.data.estimation_work_order_id
            this.data.ppn_included = false;
        }
        else {
            this.selected = 'Part'
            this.page = 2;
        }
        
        // console.log(this.form)
    },
    watch : {
        'data.sparepart_id' : function () {
            this.data.part_number = ''
            this.data.extension = ''
            this.data.sparepart_size = null
            this.data.type = null
        },
        page : function () {
            if(this.page == 3 && this.data.attachment_id) {
                this.loadAttachmentData()
            }
            else {
                this.attachmentList = []
            }
        },
        'data.type' : function () {
            if(!this.data.type) return
            // console.log(this.data.sparepartInfo.modal_jasa)
            if(!Array.isArray(this.data.sparepartInfo.modal_jasa)) return

            if(this.data.sparepartInfo.sparepart_variants.name == 'Others') return;

            let curJasaUp = this.data.sparepartInfo.modal_jasa.find(x => x.type == this.data.type)

            this.data.modal_jasa = parseFloat(curJasaUp.price);
        }
    },
    methods : {
        addEstimationPart () {
            let valid = true

            valid = this.validateForm(this.data , this.selected)
            
            for(var i = 0 ; i < this.attachmentList.length ; i++) {
                let curData = this.attachmentList[i]
                valid = this.validateForm(curData , 'Jasa')

            }

            if(valid) {
                this.addEstimationToTable(this.data , this.selected)
                for(var i = 0 ; i < this.attachmentList.length ; i++) {
                    let curData = this.attachmentList[i]
                    this.addEstimationToTable(curData , 'Jasa')
                }
            }
        },
        async loadAttachmentData () {
            try {
                let response = await this.$http.get('/api/v1/sparepart-attachments?id=' + this.data.attachment_id)
                // this.attachmentList = response.data.data
                
                let data = response.data.data[0].sparepart_services
                // console.log(response.data.data)

                for(var i = 0 ; i < data.length ; i++) {
                    let curData = data[i]
                    let obj = Object.assign({} , this.sparePart)

                    obj.sparepart_id = curData.sparepart_id
                    obj.amount = 1
                    // obj.sparepartInfo = data[i]
                    obj.sparepartInfo = await this.searchSparepartIDNonPage(curData)
                    this.attachmentList.push(obj)



                }
            }
            catch(err) {
                console.log(err)
                this.$store.dispatch('triggerAlert' , [false , 'Failed to load attachment module.'])
            }
        },
        async submitForm() {
			if(this.processSparepart) {
				this.$store.dispatch('triggerAlert' , [false , 'Sparepart is processing.. please wait a moment'])
				return
			}

            if(this.estimationSubmitList.length < 1) {
                this.$store.dispatch('triggerAlert' , [false , 'Estimasi tidak boleh kosong.'])
                this.processSparepart = false;
                return
            }
			this.processSparepart = true
            let data = JSON.parse(JSON.stringify(this.estimationSubmitList))
            // console.log(data)
            // data.sparepart_id = data.sparepart_id.id
            // data.sparepart_type = this.sparepart_type
            // if(this.selected == 'Jasa') {
            //     data.price_per_item = data.price_per_item.toString()
            //     data.price_per_item = data.price_per_item.includes(',') ?  parseFloat(data.price_per_item.split(',').join('')) : parseFloat(data.price_per_item)
            // }

            for(var i = 0 ; i< data.length ; i++) {
                let curData = data[i]

                data[i].price_per_item = data[i].price_per_item ? parseFloat(data[i].price_per_item) : null
                data[i].modal_jasa ? data[i].modal_jasa = parseFloat(data[i].modal_jasa) : delete data[i].modal_jasa

                if(this.approveInstant){
                    data[i].is_approved_by_insurance = true
                    data[i].is_supplied_by_insurance = false
                }

                if(curData.selected == 'Jasa') {
                    curData.price_per_item = curData.price_per_item.toString()
                    curData.price_per_item = curData.price_per_item.includes(',') ?  parseFloat(curData.price_per_item.split(',').join('')) : parseFloat(curData.price_per_item)
                }
                else  {
                    delete curData.sparepart_size
                }

                curData.sparepart_type = curData.selected.slice(0 ,1)
                curData.ppn_included = curData.ppn_included ? curData.ppn_included : false;
                delete curData.selected
                delete curData.attachment_id
                delete curData.sparepartInfo
            }
            

            // data.attachment_id != null ? data.force_add = true : data.force_add = false;
            // console.log(data)
            
            this.$http.post('/api/v1/estimations' , data)
            .then((resp) => {
                this.$store.dispatch('triggerAlert', [true, [`Sparepart Berhasil Ditambah`]]);
                this.processSparepart = false

                // this.$emit('updateTable');
                // this.$emit('closeModal');
                if(this.type == 'PartsOnly') this.$router.push({name : 'EstimatorParts' , params : { 'id' : this.form_code}})
                else this.$router.push({name : 'EstimatorApplication' , params : {id : this.form_code}})
            })
            .catch((err) => {

                let errObj = err.response.data.data
                let errMessage = ''
                if(errObj.name == 'DBError') {
                    errMessage = errObj.nativeError.sqlMessage
                }
                else {
                    errMessage = errObj.message
                }
                // console.log(errObj)

                this.$store.dispatch('triggerAlert' , [false, errMessage])
                this.processSparepart = false
            })
		},
        updateDescription (text) {
            console.log(text)
			this.$set(this.data , 'part_number' , text)
		},
        addPriceListDB () {
			this.formPriceList = Object.assign({} , this.formPriceList)
			this.formPriceList.sparepart_id = this.data.sparepart_id

			
			this.formPriceList.price = parseFloat(this.addPriceList)
			if(this.formPriceList.price <= 0) {
				this.$store.dispatch('triggerAlert' , [false , 'Harga Pricelist tidak boleh kosong'])
				return
			}
			delete this.formPriceList.sparepart_size
			delete this.formPriceList.attachment_id
			this.$http.post('/api/v1/insurance/pricelist', this.formPriceList)
			.then((resp )=> {
				this.data.price_per_item = parseFloat(this.addPriceList)
				this.price = this.data.price_per_item

                this.formPriceList = JSON.parse(JSON.stringify(this.form))
			})
			.catch((err) => {
				console.log(err)
			})
		},
        addEstimationToTable (data = this.data , selected = this.selected) {
            if(this.selected == 'Jasa' && this.price == 0){
                this.$store.dispatch('triggerAlert' , [false , 'Tolong Input Pricelist Jasa Sebelum Menambahkan Estimasi'])
                return
            }

            if(this.validateForm(data , selected)){
                let obj = Object.assign({} , data)
                obj.selected = selected

                this.estimationSubmitList.push(obj)

                this.sparePart.estimation_work_order_id = obj.estimation_work_order_id

                // this.data = Object.assign({} , this.sparePart)
                this.$set(this , 'data' , this.sparePart)

                if(this.type == 'PartsOnly') {
                    this.page = 2;
                    this.selected = 'Part'
                }
                else
                    this.page = 1
            }
        },
        searchSparepartID (sparepart ) {
			let url = `/api/v1/masterData/sparepart`

			this.$http.get(url + `?variant_id=${sparepart.id}`)
			.then((resp) => {
				// this.data.sparepart_id = resp.data.data[0]
                let data = resp.data.data[0]
                this.data.sparepart_id = resp.data.data[0].id
                this.data.sparepartInfo = data

                if(data.sparepart_variants.extension){
                    this.extensionList = data.sparepart_variants.extension.split(',')
                }

                if(data.sparepart_variants.description){
                    this.descriptionList = data.sparepart_variants.description.split(',')
                }
                    
                    
                // console.log(data)
                if(this.type != 'PartsOnly' && this.type != 'Process Mobil')
                    
				    this.price = this.insurancePriceList.find(x => x.sparepart_id == this.data.sparepart_id)
                // console.log(this.price)
                
				this.price = this.price ? this.price : 0
				if(this.sparepart_type == 'J')
					this.data.price_per_item = this.price ? parseFloat(this.price.price) : null
				else {
					delete this.data.price_per_item
					this.data.attachment_id = data.sparepart_variants.sparepart_attachment_id
				}
                this.page++;
                console.log(this.data)

			})
			.catch((err) => {
				console.log(err)
			})
		},
        async searchSparepartIDNonPage (sparepart ) {
            try {
                let url = `/api/v1/masterData/sparepart`
                let resp = await this.$http.get(url + `?variant_id=${sparepart.sparepart_variant_id}`)
                
                return resp.data.data[0]
            }
            catch (err) {
                console.log(err)
            }
		},
        validateForm(data , selected){
			var valid = true;
			var error = [];
			data.amount  = parseFloat(data.amount)
			if(data.sparepart_id == '' || data.sparepart_id == null){//Sparepart [Required]
				valid = false;
				error.push('Sparepart wajib dipilih!');
			}

			if(data.amount <= 0 ){//Name [Required]
				valid = false;
				error.push('Jumlah Sparepart tidak boleh 0!');
			}

			if(selected == 'Jasa' && (data.sparepart_size == '' || !data.sparepart_size)) {
				valid = false;
				error.push('Sparepart Size Tidak Boleh Kosong.');
			}

			if(selected == 'Part' && (data.part_number == '' || !data.part_number)) {
				valid = false;
				error.push('Part Description Tidak Boleh Kosong.');
			}

			if(selected == 'Jasa' && (data.price_per_item == '' || !data.price_per_item)) {
				valid = false;
				error.push('Harga Jasa Tidak Boleh Kosong.');
			}

			if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        	else return valid;
		},
        loadSparepartData () {
			this.sparepartMaster = null

			let data = {
				Jasa : [],
				Part : [],
				Bahan : [],
                'Special Bahan' : []
			}
			this.$http.get(`/api/v1/masterData/sparepart/variants?pagination=false&countEstimation=true`)
			.then((resp) => {
				let sparepartMaster = resp.data.data
				for(var i = 0 ; i < sparepartMaster.length ; i++) {
                    if(sparepartMaster[i].sparepart_type.id == 1 && sparepartMaster[i].is_show) {
                        data.Jasa.push(sparepartMaster[i])
                    }
                    else if(sparepartMaster[i].sparepart_type.id == 2) {
                        data.Part.push(sparepartMaster[i])
                    }
                    else if(sparepartMaster[i].sparepart_type.id == 4) {
                        data['Special Bahan'].push(sparepartMaster[i])
                    }
				}

				this.sparepartMaster = data
				// console.log(this.sparepartMaster)
			})
			.catch((err) => {console.log(err)})
		}
    }
}
</script>

<style scoped>
    .scrollable-card {
        min-height : 400px;
        overflow-y : scroll;
    }

    .flexify {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .height-tipe {
        height : 320px;
    }

    .height-item {
        height : 80px;
    }

    .hoverable:hover {
        color : white;
        background-color: darkslategrey;
    }

    .sub-text{
        white-space: normal;
    }

    .label {
        text-align: left;
    }
</style>